import React, { useState } from 'react';
import { Alert, Box, Button, Container, Link, Paper, Stack, TextField, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { requestRegistrationCode, verifyRegistrationCode } from '../services/auth';
import { useAuth } from '../context/AuthContext';
import { normalizeEmailInput, russianEmailError } from '../utils/email';

const detail = (error) => {
  const value = error.response?.data?.detail;
  if (Array.isArray(value)) return String(value[0]?.msg || 'Некорректные данные').replace(/^Value error, /, '');
  return value || 'Не удалось выполнить запрос';
};

const InviteRegistrationPage = () => {
  const { referrerId } = useParams();
  const navigate = useNavigate();
  const { acceptToken } = useAuth();
  const [step, setStep] = useState('details');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const invited = referrerId !== undefined;
  const validReferral = !invited || (/^-?\d+$/.test(referrerId || '') && Number(referrerId) !== 0);

  const requestCode = async (event) => {
    event.preventDefault(); setBusy(true); setError('');
    const normalizedEmail = normalizeEmailInput(email);
    const blocked = russianEmailError(normalizedEmail);
    if (blocked) { setError(blocked); setBusy(false); return; }
    try {
      await requestRegistrationCode(normalizedEmail, username.trim(), referrerId);
      setEmail(normalizedEmail); setStep('code');
    } catch (err) { setError(detail(err)); }
    finally { setBusy(false); }
  };

  const register = async (event) => {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const result = await verifyRegistrationCode(email, code);
      await acceptToken(result.access_token);
      navigate('/dashboard', { replace: true });
    } catch (err) { setError(detail(err)); }
    finally { setBusy(false); }
  };

  return <Box className="noise-bg" minHeight="100vh" display="grid" sx={{ placeItems: 'center' }} py={5}><Container maxWidth="xs"><Paper sx={{ p: 4 }}><Box component="img" src="/nox-logo.png" alt="NOX VPN" className="brand-logo" sx={{ mb: 4 }}/><Typography variant="h4">{invited ? 'Вас пригласили в NOX' : 'Регистрация в NOX'}</Typography><Typography color="text.secondary" mt={1} mb={4}>{step === 'details' ? 'Создайте аккаунт на сайте. Российская почта не поддерживается.' : `Введите код, отправленный на ${email}`}</Typography>{!validReferral && <Alert severity="error" sx={{ mb: 2 }}>Реферальная ссылка повреждена</Alert>}{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}{step === 'details' ? <Box component="form" onSubmit={requestCode}><Stack spacing={2}><TextField required autoFocus label="Имя пользователя" value={username} onChange={(e) => setUsername(e.target.value.replace(/[^A-Za-z0-9_]/g, ''))} helperText="3–32 символа: латинские буквы, цифры и _" inputProps={{ minLength: 3, maxLength: 32 }}/><TextField required type="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" helperText="Домены .ru/.su/.рф, mail.ru, yandex, rambler, vk и другие российские сервисы не принимаются"/><Button type="submit" variant="contained" endIcon={<ArrowForward/>} disabled={busy || !validReferral || username.length < 3}>{busy ? 'Отправляем…' : 'Получить код'}</Button></Stack></Box> : <Box component="form" onSubmit={register}><Stack spacing={2}><TextField required autoFocus label="Код из письма" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} inputProps={{ pattern: '[0-9]{6}', inputMode: 'numeric' }}/><Button type="submit" variant="contained" disabled={busy || code.length !== 6}>{busy ? 'Создаём аккаунт…' : 'Зарегистрироваться'}</Button><Button startIcon={<ArrowBack/>} onClick={() => { setStep('details'); setCode(''); setError(''); }}>Изменить данные</Button></Stack></Box>}<Typography color="text.secondary" textAlign="center" mt={4}>Уже зарегистрированы? <Link component={RouterLink} to="/login">Войти</Link></Typography></Paper></Container></Box>;
};

export default InviteRegistrationPage;
